import React from 'react';
import { Link } from 'react-router-dom';
import { useSubdomain } from '../hooks/useSubdomain';
import { useAssets } from '../hooks/useAssets';
import { useMetadata } from '../contexts/MetadataContext';
import '../styles/Header.css';

function Header() {
  const { subdomain } = useSubdomain();
  const { getSpecificAsset, getCommonAsset } = useAssets();
  const metadata = useMetadata();

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/home">
            <img 
              src={getSpecificAsset('ui', 'logo.svg')}
              alt={`${metadata.title} Logo`}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = getCommonAsset('ui', 'logo.svg');
              }}
            />
          </Link>
        </div>
        <h1 className="site-title">{metadata.title.split('|')[0].trim()}</h1>
        <nav className="main-nav">
          <ul>
            <li><Link to="/home">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
